var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "overflow-visible",
    attrs: {
      "width": "100%",
      "elevation": "0",
      "color": "transparent",
      "to": "/shop/products/".concat(_vm.product._id)
    }
  }, [_c('v-responsive', {
    attrs: {
      "width": "100%",
      "aspect-ratio": "1"
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex align-center",
    attrs: {
      "width": "100%",
      "height": "100%",
      "outlined": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.product.thumb,
      "max-width": "500",
      "contain": "",
      "aspect-ratio": 3 / 2
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center mt-14px px-10px"
  }, [_c('div', [_c('div', {
    staticClass: "font-size-16 font-size-md-18 font-weight-medium text-truncate"
  }, [_vm._v(_vm._s(_vm.product.name))])]), _c('div', {
    staticClass: "mt-4px"
  }, [_c('v-row', {
    staticClass: "font-size-14 grey--text text--darken-2",
    staticStyle: {
      "white-space": "nowrap",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    },
    attrs: {
      "no-gutters": "",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "text-truncate"
  }, [_vm._v(_vm._s(_vm.product.writer))]), _vm.product.writer && _vm.product.publisher ? _c('v-divider', {
    staticClass: "mx-8px",
    staticStyle: {
      "max-height": "10px",
      "min-height": "10px"
    },
    attrs: {
      "vertical": ""
    }
  }) : _vm._e(), _c('span', {
    staticClass: "text-truncate"
  }, [_vm._v(_vm._s(_vm.product.publisher))])], 1)], 1)], 1), _c('div', {
    staticClass: "mt-4px"
  }, [_c('div', {
    staticClass: "font-size-16"
  }, [_c('b', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.product.salePrice.format()))]), _vm._v("원 ")])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }